import React, { useContext } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { MenuFoldOutlined, MenuUnfoldOutlined, PoweroffOutlined, UserOutlined } from '@ant-design/icons'
import { Avatar, Button } from 'antd'
import TopBar from '../../components/TopBar'
import Login from '../../components/Login'
import { AuthContext } from '../../context/AuthContextProvider'

function Classic() {
    const { logOut, isLoggedIn, user } = useContext(AuthContext);

    const navigate = useNavigate();

    if (isLoggedIn) {
        return (
            <div className={'m-auto max-h-screen h-screen flex justify-center items-center bg-slate-500'}>
                <div className='bg-slate-50 border margin-auto max-w-screen-xl w-screen overflow-y-auto' style={{ height: 'calc(100vh - 80px)'}}>
                    <div className='sticky top-0 bg-blue-50 pr-5 py-2 z-40 flex border-b'>
                        <div className=''><TopBar hidden={false} /></div>
                        <div className='grow text-right px-2 text-sm cursor-pointer' onClick={() => navigate('/profile')}><Avatar className='mr-2' icon={<UserOutlined />} />{user.userName} <Button type='link' onClick={logOut}><PoweroffOutlined /></Button></div>
                    </div>
                    <div className='p-5'><Outlet /></div>
                </div>
            </div>
        )
    } else {
        return <Login />
    }
}

export default Classic;